import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'react-apollo';
import messages from '../../locale/messages';
import s from './PaymentError.css';

class PaymentError extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    errorMessage: PropTypes.string
  };

  static defaultProps = {
    errorMessage: null
  };

  componentDidMount() {
    window.localStorage.removeItem('pendingReservationId');
  }

  render() {
    const { errorMessage } = this.props;
    
    return (
      <div className={s.root}>
        <div className={s.container}>
          <h1><FormattedMessage {...messages.failed} /></h1>
          {errorMessage && (
            <p className={s.errorText}><FormattedMessage {...messages.errorPrefix} /> {errorMessage}</p>
          )}
          <p><FormattedMessage {...messages.error} /></p>
          <ul>
            <li><FormattedMessage {...messages.insufficientFunds} /></li>
            <li><FormattedMessage {...messages.cardDeclined} /></li>
            <li><FormattedMessage {...messages.networkIssues} /></li>
            <li><FormattedMessage {...messages.paymentCancelled} /></li>
          </ul>
          <p>
            <FormattedMessage {...messages.youCan} />
            {' '}<a href="/trips/current"><FormattedMessage {...messages.viewBookings} /></a>,
            {' '}<a href="/"><FormattedMessage {...messages.returnToHomepage} /></a>,
            {' '}<FormattedMessage {...messages.or} />
            {' '}<FormattedMessage {...messages.tryBookingAgain} />.
          </p>
        </div>
      </div>
    );
  }
}

const mapState = state => ({
});

export default compose(
  injectIntl,
  withStyles(s),
  connect(mapState)
)(PaymentError);